<template>
  <div class="Head-area">
    <div class="toplink">
      <div class="container">
        产品中心：<router-link
          v-for="(item, index) in proTypes"
          :key="index"
          :to="{ path: '/productCenter', query: { typename: item.id } }"
          >{{ item.name }}</router-link
        >
      </div>
    </div>
    <div class="area container dis_flex dis_ali dis_jucontween">
      <div class="logo">
        <router-link to="/"
          ><img
            src="../assets/04.png"
            alt="万杰智能科技股份有限公司"
            title="万杰智能科技股份有限公司"
        /></router-link>
      </div>
      <div class="intro">
        <!-- 24年专注智能面食机械研发生产<br />
        提供中央厨房整体设计解决方案 -->
        <!-- {{year}}年专注<b>智能</b>面食机械的研发生产<br />
        拥有145项自主知识产权 -->
      </div>
      <div class="telotheer">
        <div class="other dis_flex dis_ali dis_jucont_end">
          <div
            class="search"
            @mouseover="searchBarShow = true"
            @mouseleave="searchBarShow = false"
          >
            <img src="../assets/05.png" alt="万杰智能科技股份有限公司" />
            <div class="search-bar" v-if="searchBarShow">
              <div class="triangel-warp"><p class="white-triangel"></p></div>
              <div class="header-search-wrap">
                <input
                  type="text"
                  autocomplete="off"
                  placeholder="搜索相关产品信息"
                  v-model="searchText"
                />
                <router-link
                  :to="{ name: 'searchCenter', query: { search: searchText } }"
                  id="btnHeaderSearch"
                  class="header-search-btn"
                  >搜索</router-link
                >
              </div>
            </div>
          </div>
          <div class="center">
            <a href="https://mail.126.com/" target="_blank">企业邮箱</a>
          </div>
          <div class="en">
            <!-- http://www.wanjieen.com/ -->
            <a href="" target="_blank">En</a>
          </div>
        </div>
        <div class="tel">400-677-1996</div>
      </div>
    </div>
    <div class="nav">
      <ul class="container dis_flex dis_ali ">
        <li>
          <router-link exact active-class="active" to="/" class="main-link"
            >首页</router-link
          >
        </li>
        <li @mouseover="showNav(2)" @mouseleave="showNav(0)">
          <router-link to="/aboutus" active-class="active" class="main-link"
            >关于万杰</router-link
          >
          <ul
            class="dis_flex dis_ali dis_juconspace"
            v-if="navindex == 2"
            style="width: 700px;"
          >
            <li><router-link to="/aboutus/intro">公司介绍</router-link></li>
            <li><router-link to="/aboutus/speech">董事长致辞</router-link></li>
            <li><router-link to="/aboutus/culture">企业文化</router-link></li>
            <li>
              <router-link to="/aboutus/qualification">企业资质</router-link>
            </li>
            <li><router-link to="/aboutus/journal">万杰期刊</router-link></li>
            <li><router-link to="/aboutus/videos">视频展示</router-link></li>
          </ul>
        </li>
        <li @mouseover="showNav(3)" @mouseleave="showNav(0)">
          <router-link active-class="active" to="/news" class="main-link"
            >新闻动态</router-link
          >
          <ul
            class="dis_flex dis_ali dis_juconspace"
            v-if="navindex == 3"
            style="width: 200px;"
          >
            <li><router-link to="/news/company">公司新闻</router-link></li>
            <li><router-link to="/news/industry">行业动态</router-link></li>
          </ul>
        </li>
        <li @mouseover="showNav(4)" @mouseleave="showNav(0)">
          <router-link
            active-class="active"
            to="/productCenter"
            class="main-link"
            >产品展示</router-link
          >
          <!-- :style="'width:'+ (proTypes.length*100) +'px;'"-->
          <ul
            class="dis_flex dis_ali flex_wrap productCenter"
            v-if="navindex == 4"
          >
            <li v-for="(item, index) in proTypes" :key="index">
              <router-link
                :to="{ path: '/productCenter', query: { typename: item.id } }"
                >{{ item.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li @mouseover="showNav(5)" @mouseleave="showNav(0)">
          <router-link
            active-class="active"
            to="/serviceCooperation"
            class="main-link"
            >服务与合作</router-link
          >
          <ul
            class="dis_flex dis_ali dis_juconspace"
            v-if="navindex == 5"
            style="width: 200px;"
          >
            <li>
              <router-link to="/serviceCooperation/problem"
                >常见问题</router-link
              >
            </li>
            <li>
              <router-link to="/serviceCooperation/policy"
                >维修政策</router-link
              >
            </li>
          </ul>
        </li>
        <li @mouseover="showNav(6)" @mouseleave="showNav(0)">
          <router-link
            active-class="active"
            to="/relationship"
            class="main-link"
            >投资者关系</router-link
          >
          <ul
            class="dis_flex dis_ali dis_juconspace"
            v-if="navindex == 6"
            style="width: 200px;"
          >
            <li>
              <router-link to="/relationship/notice">公司公告</router-link>
            </li>
            <li>
              <router-link to="/relationship/members">董事会成员</router-link>
            </li>
          </ul>
        </li>
        <li @mouseover="showNav(7)" @mouseleave="showNav(0)">
          <router-link active-class="active" to="/contactus" class="main-link"
            >联系我们</router-link
          >
          <ul
            class="dis_flex dis_ali dis_juconspace contactus"
            v-if="navindex == 7"
            style="width: 300px;"
          >
            <li><router-link to="/contactus/presale">售前咨询</router-link></li>
            <li>
              <router-link to="/contactus/aftersales">售后支持</router-link>
            </li>
            <li><router-link to="/contactus/message">在线留言</router-link></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear() - 1996,
      navindex: 0,
      navs: this.$router.options.routes,
      searchText: "",
      searchBarShow: false,
      proTypes: []
    };
  },
  watch: {
    $route(to, from, newxt) {
      // '$route.query' 这个函数是关键
      // console.log(to.paht)
      if (to.path !== "/searchCenter") {
        this.searchText = "";
      }
    }
  },
  computed: {
    filterNav: function() {
      return this.navs.filter(function(item) {
        if (item.meta.show) {
          return item;
        }
      });
    }
  },
  mounted() {
    // console.log(this.$router.options.routes)
    this.$https
      .fetchPost("/Product/product_class_list", {})
      .then(res => {
        // console.log(res.data)
        this.proTypes = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  components: {},
  methods: {
    showNav: function(navindex) {
      this.navindex = navindex;
    }
  }
};
</script>
<style lang="less">
@import url("../../static/style.less");
.Head-area {
  position: relative;
  .toplink {
    margin-bottom: 25px;
    background-color: #333;
    padding: 10px 0;
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0;
    color: #b0b0b0;
    a {
      color: #b0b0b0;
      padding: 0 5px;
      position: relative;
      &:hover {
        color: #ffffff;
      }
      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -5px;
        height: 10px;
        width: 1px;
        background: hsla(0, 0%, 69%, 0.22);
      }
    }
  }
  .logo {
    width: 194px;
    height: 70px;
  }
  .intro {
    flex: 1;
    margin-left: 10px;
    font-size: 13px;
    line-height: 18px;
    color: #888888;
  }
  .tel {
    font-size: 26px;
    font-weight: 700;
    display: block;
    color: #22bdc1;
    background: url("../assets/tel.jpg") no-repeat 0;
    background-size: 26px;
    padding-left: 35px;
  }
  .other {
    margin: -15px 0 10px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.4px;
    color: #888888;
    a {
      color: #888888;
      &:hover {
        color: #22bdc1;
      }
    }
    .search {
      width: 14px;
      // height: 16px;
      padding: 5px 12px 5px 0;
      cursor: pointer;
      box-sizing: content-box;
    }
    .center {
      padding: 0 10px;
      margin: 0 10px 0 0;
      position: relative;
      z-index: 2;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        top: 50%;
        left: 0;
        height: 13px;
        margin-top: -6.5px;
        border-left: 1px solid #ebebeb;
      }
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        top: 50%;
        right: 0;
        height: 13px;
        margin-top: -6.5px;
        border-right: 1px solid #ebebeb;
      }
    }
  }
  .nav {
    margin-top: 25px;
    background: #22bdc1;
    font-family: PingFang-SC-Regular;
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 110px;
    letter-spacing: 0.5px;
    color: #303245;

    li {
      width: 14.3%;
      text-align: center;
      line-height: 50px;
      position: relative;

      .main-link {
        color: #ffffff;

        display: block;
        &:hover {
          color: #fff;
          background: rgba(255, 255, 255, 0.2);
        }
      }
      .active {
        color: #fff;
        background: rgba(255, 255, 255, 0.2);
        display: block;
      }
      ul {
        position: absolute;
        left: 0;
        top: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 9.4px 0.6px rgba(12, 3, 6, 0.08);
        z-index: 10;
        border-radius: 5px;
        &::before {
          content: "";
          position: absolute;
          top: -8px;
          left: 70px;
          width: 15px;
          height: 15px;
          transform: rotate(45deg);
          background-color: #ffffff;
          border-top: 0.6px solid rgba(12, 3, 6, 0.08);
          border-left: 0.6px solid rgba(12, 3, 6, 0.08);
        }
      }
      ul > li {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        line-height: 65px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.4px;
        color: #303245;
        width: auto;
        &:first-child {
          position: relative;
        }
        &:hover {
          a {
            color: #22bdc1;
          }
        }
      }

      .productCenter {
        width: 750px;
        left: -70px;
        padding: 10px 0 10px 30px;
        &::before {
          left: 19.5%;
        }
        li {
          line-height: 40px;
          width: 20%;
          text-align: left;
        }
      }
      .contactus {
        left: auto;
        right: 0;
        &::before {
          left: auto;
          right: 80px;
        }
      }
    }
  }

  .search-bar {
    width: 100%;
    background: transparent;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 3;
    top: 40px;
    z-index: 10;
    padding-top: 50px;
    box-sizing: content-box;
    box-shadow: 0 19px 19px 0 rgba(0, 0, 0, 0.1);
    .triangel-warp {
      display: none;
      width: 100%;
      max-width: 1370px;
      margin: 0 auto;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: -8px;
        right: 9.2%;
        width: 15px;
        height: 15px;
        transform: rotate(45deg);
        background-color: #ffffff;
        border-top: 0.6px solid rgba(12, 3, 6, 0.08);
        border-left: 0.6px solid rgba(12, 3, 6, 0.08);
      }
    }

    .header-search-wrap {
      background: #ffffff;
      font-size: 16px;
      padding: 100px 0;
      text-align: center;
      input {
        width: 620px;
        height: 50px;
        background: #fbfbfb;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding-left: 15px;
      }
      .header-search-btn {
        display: inline-block;
        margin-left: 30px;
        width: 120px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        background: #22bdc1;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue